import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SelectedDropdownItem, SingleSelectFilterConfig, SingleSelectTemplateState } from '../interface';
import { ItemSearchSelectFilterService } from '../item-search-select-filter.service';

@Component({
  selector: 'inventory-ui-item-search-single-select-filter',
  templateUrl: './item-search-single-select-filter.component.html',
  styleUrls: ['./item-search-single-select-filter.component.scss'],
  providers: [ItemSearchSelectFilterService],
  standalone: false,
})
export class ItemSearchSingleSelectFilterComponent implements OnInit {
  @Input() config: SingleSelectFilterConfig = {
    partnerId: '',
  };

  @Input() set selectedItem(value: SelectedDropdownItem | null) {
    if (value && (value.appId || value.addonId)) {
      this.itemSearchSelectFilterService.updateSelection([value]);
    } else {
      this.itemSearchSelectFilterService.updateSelection([]);
    }
  }

  @Output() selectionChange: EventEmitter<SelectedDropdownItem> = new EventEmitter<SelectedDropdownItem>();

  templateState$!: Observable<SingleSelectTemplateState>;
  searchCtrl = new UntypedFormControl('');

  constructor(private readonly itemSearchSelectFilterService: ItemSearchSelectFilterService) {}

  ngOnInit(): void {
    const searchCtrl$ = this.searchCtrl.valueChanges.pipe(
      filter((term) => typeof term === 'string'),
      map((searchTerm) => searchTerm ?? ''),
    );

    this.templateState$ = this.itemSearchSelectFilterService
      .init(searchCtrl$, this.config, true)
      .pipe(map((state) => ({ ...state, selectedItem: state.selectedItems?.[0] || null })));
  }

  addItem(event: MatAutocompleteSelectedEvent, selectedItem: SelectedDropdownItem | null): void {
    const newlySelectedItem = event?.option?.value as SelectedDropdownItem;
    if (!newlySelectedItem) return;

    const isAlreadySelected =
      selectedItem &&
      selectedItem.appId === newlySelectedItem.appId &&
      selectedItem.addonId === newlySelectedItem.addonId;
    if (isAlreadySelected) return;

    this.searchCtrl.setValue('');
    this.itemSearchSelectFilterService.updateSelection([newlySelectedItem]);
    this.selectionChange.emit(newlySelectedItem);
  }

  loadMore(): void {
    this.itemSearchSelectFilterService.triggerLoadMore();
  }

  displayFn(item: SelectedDropdownItem | null): () => string {
    return () => {
      return item?.name ?? '';
    };
  }
}
